import React from 'react';
const moment = require('moment');
import Dropdown from 'react-dropdown';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import { Wordp, Magento, InteConnect, bigcomfull, shopifyfull } from '../../img'; // Nopc, Presta, Openc,

const PageOption = [
  { value: 'all', label: 'All pages' },
  { value: 'home', label: 'Home page' },
  { value: 'product', label: 'Product page' },
  { value: 'collection', label: 'Collection page' },
  { value: 'blog', label: 'Blog page' }
];

const Position = [
  { value: 'top', label: 'Top' },
  { value: 'bottom', label: 'Bottom' }
];

const GetCodeCard = ({
  divTag,
  divId,
  _Iframe,
  _shareURL,
  objWidget,
  state,
  setIntName,
  addShpWidgetDiv,
  rdtShpPage,
  deleteWidgetDiv,
  copyWidgetDiv,
  // installFBTab,
  handleInputchange,
  getShpThemeList,
  handleGetCodeTabClick,
  getCodeTabName,
  widgetByIdDsi
}) => {
  return (
    widgetByIdDsi && widgetByIdDsi.length > 0 ?
      <div className="modal-installation">
        <div className="modal-inst-header">
          <h4 className="modal-inst-hdtitle">Copy your Wall snippet</h4>
          {
            !objWidget.isCreateInt && (objWidget.cn == 'social' || objWidget.cn == 'review') &&
            <div className="modal-coonect-intra">
              <h3 className="intra-conect-text">You don't have any active integration <span className="link-text" onClick={() => setIntName()}>Click here</span> to connect integration</h3>
            </div>
          }
        </div>
        {(objWidget.cn == 'social' || objWidget.cn == 'review') ?
          <div className=''>
            <Tabs className="nf-default-tabs nf-tabs-fullline-bg" defaultIndex={0}>
              <TabList>
                <Tab onClick={() => handleGetCodeTabClick('javascript')}>Javascript</Tab>
                <Tab onClick={() => handleGetCodeTabClick('iframe')}>Iframe</Tab>
              </TabList>
              <TabPanel>
                <div className="tabs-fullline-bg-content">
                  <h3 className='copycode-paste-title'>Copy and paste this code into desired place of your website (html editor, website template, theme, etc)</h3>
                  {/* Javascript */}
                  {getCodeTabName == 'javascript' &&
                    <div className="inst-code-design">
                      <div className="inst-types-manually">
                        <div className="copycode-box">
                          <textarea className="textarea-copycode" readOnly={true} value={divTag} onClick={(e) => copyWidgetDiv(divTag, e)}>
                          </textarea>
                        </div>
                        {/* <div className="wdgt-code-script"><pre>{divTag}</pre></div> */}
                        <div className="copy-script-upbg">
                          <div className="copy-script-content">
                            <a className="nf-btn nf-btn-default" onClick={() => copyWidgetDiv(divTag)}>
                              <span className="btn-copytext-dflt">Copy Code</span>
                              <span className="btn-copytext-hover">Copy code</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div className="instll-ntv-part">
                    <h3 className='copycode-paste-title'>Install pixel using native app</h3>
                    <div className='native-app-flex'>
                      <a href='https://support.wisernotify.com/embed-social-wall-code-on-shopify-store/' target="_blank" className='imaglink'>
                        <img src={shopifyfull} alt="shopify" />
                      </a>
                      <a href='#' target="_blank" className='imaglink'>
                        <img src={Wordp} alt="Wordp" />
                      </a>
                      <a href='#' target="_blank" className='imaglink'>
                        <img src={Magento} alt="Magento" />
                      </a>
                      <a href='#' target="_blank" className='imaglink'>
                        <img src={bigcomfull} alt="bigcom" />
                      </a>
                      {/* <img src={Openc} alt="Openc" />
                      <img src={Presta} alt="Presta" />
                      <img src={Nopc} alt="Nopc" /> */}
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="tabs-fullline-bg-content">
                  <h3 className='copycode-paste-title'>Copy and paste this code into desired place of your website (html editor, website template, theme, etc)</h3>
                  {/* Iframe */}
                  {getCodeTabName == 'iframe' &&
                    <div className="inst-code-design">
                      <div className="inst-types-manually">
                        <div className="copycode-box">
                          <textarea className="textarea-copycode" readOnly={true} value={_Iframe} onClick={(e) => copyWidgetDiv(_Iframe, e)}>
                          </textarea>
                        </div>
                        {/* <div className="wdgt-code-script"><pre>{_Iframe}</pre></div> */}
                        <div className="copy-script-upbg">
                          <div className="copy-script-content">
                            <a className="nf-btn nf-btn-default" onClick={() => copyWidgetDiv(_Iframe)}>
                              <span className="btn-copytext-dflt">Copy Code</span>
                              <span className="btn-copytext-hover">Copy code</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div className="instll-ntv-part">
                    <h3 className='copycode-paste-title'>Install pixel using native app</h3>
                    <div className='native-app-flex'>
                      <a href='https://support.wisernotify.com/embed-social-wall-code-on-shopify-store/' target="_blank" className='imaglink'>
                        <img src={shopifyfull} alt="shopify" />
                      </a>
                      <a href='#' target="_blank" className='imaglink'>
                        <img src={Wordp} alt="Wordp" />
                      </a>
                      <a href='#' target="_blank" className='imaglink'>
                        <img src={Magento} alt="Magento" />
                      </a>
                      <a href='#' target="_blank" className='imaglink'>
                        <img src={bigcomfull} alt="bigcom" />
                      </a>
                      {/* <img src={Openc} alt="Openc" />
                      <img src={Presta} alt="Presta" />
                      <img src={Nopc} alt="Nopc" /> */}
                    </div>
                  </div>
                </div>
              </TabPanel>
            </Tabs>
            {/* <div className="install-types-item"> */}
            {/* <ul className="install-types-list">
              <li className="tab-ani-bdrinstall"></li> */}
            {/* <li>
                <span>
                  Manual
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 5.997">
                    <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M11.189,15.436l3.781-3.969a.688.688,0,0,1,1.009,0,.782.782,0,0,1,0,1.062l-4.284,4.5a.689.689,0,0,1-.985.022L6.4,12.532a.78.78,0,0,1,0-1.062.688.688,0,0,1,1.009,0Z" transform="translate(-6.188 -11.246)" />
                  </svg>
                </span>
                <div className="install-types-dd">
                  <ul className="install-types-cate">
                    {
                      localStorage.getItem('pvd') == 'shopify' &&
                      <li onClick={() => handleGetCodeTabClick('automatic')}>Automatic</li>
                    }
                    <li onClick={() => handleGetCodeTabClick('javascript')}>Javascript</li>
                    <li onClick={() => handleGetCodeTabClick('iframe')}>Iframe</li>
                  </ul>
                </div>
              </li> */}
            {/* <li>
                <span>
                  Others
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 5.997">
                    <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M11.189,15.436l3.781-3.969a.688.688,0,0,1,1.009,0,.782.782,0,0,1,0,1.062l-4.284,4.5a.689.689,0,0,1-.985.022L6.4,12.532a.78.78,0,0,1,0-1.062.688.688,0,0,1,1.009,0Z" transform="translate(-6.188 -11.246)" />
                  </svg>
                </span>
                <div className="install-types-dd">
                  <ul className="install-types-cate">
                    <li onClick={() => handleGetCodeTabClick('shopify')}>Shopify</li>
                    <li onClick={() => handleGetCodeTabClick('facebook')}>Facebook</li>
                  </ul>
                </div>
              </li> */}
            {/* </ul>
          </div> */}
            {/* Automatic */}
            {getCodeTabName == 'automatic' &&
              <div className="">
                <div className="admin-page-install">
                  <div className="install-select-page install-select-option">
                    <label>Page</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={PageOption} value={state.pgnm}
                      onChange={(e) => handleInputchange('pgnm', e.value)} />
                  </div>
                  <div className="install-select-position install-select-option">
                    <label>Position</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Position} value={state.pstn}
                      onChange={(e) => handleInputchange('pstn', e.value)} />
                  </div>
                  <div className="install-select-theme install-select-option">
                    <label>Theme</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={state.ThemeOption} value={state.thmid ?
                      state.thmid.toString() : state.thmid} onChange={(e) => handleInputchange('thmid', e)} />
                    <div className="btn-icon-defualt btn-icon-refresh" data-tip="true" data-for="sync" currentitem="false"
                      onClick={() => getShpThemeList()}>
                      <svg className={state.ThemeOption.length == 0 ? 'svg-spin-animation' : ''}
                        xmlns="http://www.w3.org/2000/svg" width="16.036" height="16.686" viewBox="0 0 16.036 16.686">
                        <path id="Path_627" data-name="Path 627"
                          d="M48.123,22.684a.6.6,0,0,0,.762.382h0L52.5,21.859a.6.6,0,0,0,.412-.572V17.67a.6.6,0,0,0-1.206,0v2.2a7.759,7.759,0,1,0,2.3,4.329.6.6,0,1,0-1.191.19l0,.011a6.638,6.638,0,1,1-1.648-3.371l-2.671.89a.6.6,0,0,0-.382.762Z"
                          transform="translate(-38.354 -16.817)" fill="#4c84ff" stroke="#4c84ff" strokeWidth="0.5">
                        </path>
                      </svg>
                    </div>
                  </div>
                  <div className="shopify-page-istbtn">
                    <span className="nf-btn nf-btn-default nf-btn-noneBdr" onClick={() => addShpWidgetDiv()}>Install Wall</span>

                  </div>
                </div>
                <div className="table-install-shopify table-responsive">
                  {!objWidget.shfyatinstlarr == '' ?
                    <table className="table tbl-header-bg tbl-th-bordernone">
                      <thead className="thead-light">
                        <tr>
                          <th className="tbl-no-col">PAGE</th>
                          <th>POSITION</th>
                          <th>INSTALLED ON</th>
                          <th>ACTIONS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          objWidget.shfyatinstlarr.length > 0 ?
                            objWidget.shfyatinstlarr.map((val, key) => {
                              let pageName = PageOption.filter(x => x.value == val.pgnm)[0].label;
                              let position = Position.filter(x => x.value == val.pstn)[0].label;
                              return (
                                <tr key={key}>
                                  <td>{`${pageName + ' (' + val.thmnm + ')'}`}</td>
                                  <td>{position}</td>
                                  <td><span>{val.insdt ? moment(new Date(val.insdt)).format('MMM-DD-YYYY') : ''}</span> </td>
                                  <td>
                                    <div className="inatall-action-btn">
                                      <div className="wdgt-icon-box25 wdgt-icon-edit wdgt-editeditor" data-tip data-for={`${'viewsite_' +
                                        key}`}>
                                        <a href={`${'https://' + localStorage.getItem('WIDSHP')}`} target='_blank'>
                                          <svg width="20px" height="20px" fill="red" viewBox="0 0 20 20" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <g id="eye" transform="translate(3.000000, 5.000000)" stroke="currentColor"
                                              stroke-linejoin="round" fill="none" strokeWidth="1.5" fill-rule="evenodd">
                                              <path stroke="#b0bec5"
                                                d="M0,5.45454545 C0,5.45454545 2.72727273,0 7.5,0 C12.2727273,0 15,5.45454545 15,5.45454545 C15,5.45454545 12.2727273,10.9090909 7.5,10.9090909 C2.72727273,10.9090909 0,5.45454545 0,5.45454545 Z">
                                              </path>
                                              <circle stroke="#b0bec5" cx="7.5" cy="5.45454545" r="2.04545455"></circle>
                                            </g>
                                          </svg>
                                        </a>
                                        <ReactTooltip id={`${'viewsite_' + key}`} aria-haspopup='true' role='example'>
                                          <p>View site</p>
                                        </ReactTooltip>
                                      </div>
                                      <div className="wdgt-icon-box25 wdgt-icon-edit wdgt-editeditor" data-tip data-for={`${'installedit_' +
                                        key}`} onClick={() => rdtShpPage(val)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.233" height="14.164" viewBox="0 0 14.233 14.164">
                                          <path id="Path_240" data-name="Path 240"
                                            d="M-31.27,55.361l2.9,2.9L-35.7,65.586l-2.894-2.9Zm5.092-.7-1.291-1.291a1.281,1.281,0,0,0-1.81,0l-1.237,1.237,2.9,2.9,1.443-1.443a.987.987,0,0,0,0-1.4Zm-13.935,12.1a.329.329,0,0,0,.4.392l3.226-.782-2.894-2.9Zm0,0"
                                            transform="translate(40.12 -52.998)" fill="#b0bec5"></path>
                                        </svg>
                                        <ReactTooltip id={`${'installedit_' + key}`} aria-haspopup='true' role='example'>
                                          <p>Customize your shopify page</p>
                                        </ReactTooltip>
                                      </div>
                                      <div className="wdgt-icon-box25 wdgt-icon-delete  wdgt-item-delete" data-tip
                                        data-for={`${'installdlt_' + key}`} onClick={() => deleteWidgetDiv(val)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 8.8 9.6">
                                          <g id="_06-trash" data-name="06-trash" transform="translate(-8)">
                                            <path id="Path_12750" data-name="Path 12750"
                                              d="M16.8,1.6H14V1.2A1.2,1.2,0,0,0,12.8,0H12a1.2,1.2,0,0,0-1.2,1.2v.4H8v.8h.442l.681,6.133A1.2,1.2,0,0,0,10.316,9.6h4.168a1.2,1.2,0,0,0,1.193-1.068L16.358,2.4H16.8Zm-5.2-.4A.4.4,0,0,1,12,.8h.8a.4.4,0,0,1,.4.4v.4H11.6Zm3.282,7.244a.4.4,0,0,1-.4.356H10.316a.4.4,0,0,1-.4-.356L9.247,2.4h6.306Z"
                                              fill="#fb5360" />
                                            <path id="Path_12751" data-name="Path 12751" d="M88,64h.8v4.8H88Z"
                                              transform="translate(-76 -60.8)" fill="#fb5360" />
                                            <path id="Path_12752" data-name="Path 12752" d="M0,0H4.817V.8H0Z"
                                              transform="translate(13.603 7.965) rotate(-85.241)" fill="#fb5360" />
                                            <path id="Path_12753" data-name="Path 12753" d="M0,0H.8V4.817H0Z"
                                              transform="translate(10.002 3.235) rotate(-4.759)" fill="#fb5360" />
                                          </g>
                                        </svg>
                                        <ReactTooltip id={`${'installdlt_' + key}`} aria-haspopup='true' role='example'>
                                          <p>Delete</p>
                                        </ReactTooltip>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                            :
                            <tr>
                              <td colSpan="4" className="text-center">No record found</td>
                            </tr>
                        }
                      </tbody>
                    </table>
                    :
                    <ContentLoader height={150} width={600} speed={2} primaryColor="#eceef4 " secondaryColor="#fff">
                      <rect x="0" y="0" rx="5" ry="5" width="600" height="70" />
                      <rect x="0" y="90" rx="5" ry="5" width="600" height="20" />
                      <rect x="0" y="125" rx="5" ry="5" width="600" height="20" />
                    </ContentLoader>
                  }
                </div>
              </div>
            }
            {/* Manual */} {/* Iframe */}  {/* Javascript */}
            {/* <div>
            {getCodeTabName == 'javascript' &&
              <div className="inst-code-design">
                <h5>Copy and paste this code into desired place of your website (HTML editor, website template, theme, etc)</h5>
                <div className="inst-types-manually">
                  <div className="wdgt-code-script">
                    <pre>{divTag}</pre>
                  </div>
                  <div className="copy-script-upbg" id={divId} onClick={() => copyWidgetDiv(divTag, divId)}>
                    <div className="copy-script-content">
                      <div className="copy-text">Copy and paste this code into desired place of your website</div>
                      <a href="#" className="nf-btn nf-btn-default">
                        <span className="btn-copytext-dflt">Get code</span>
                        <span className="btn-copytext-hover">Copy code</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            }
            {getCodeTabName == 'iframe' &&
              <div className="inst-code-design">
                <div className="inst-types-manually">
                  <div className="wdgt-code-script">
                    {_Iframe}
                  </div>
                  <div className="copy-script-upbg" id={divId} onClick={() => copyWidgetDiv(_Iframe, divId)}>
                    <div className="copy-script-content">
                      <div className="copy-text">Copy and paste this code into desired place of your website</div>
                      <a href="#" className="nf-btn nf-btn-default">
                        <span className="btn-copytext-dflt">Get code</span>
                        <span className="btn-copytext-hover">Copy code</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div> */}
            {/* Others */} {/* facebook */} {/* Shopify */}
            {/* <div>
            {getCodeTabName == 'shopify' &&
              <div className="inst-code-design">
                <button className="nf-btn nf-btn-primary nf-btn-default"> install as a shopify tab </button>
              </div>
            }
            {getCodeTabName == 'facebook' &&
              <div className="inst-code-design">
                <button className="nf-btn nf-btn-primary nf-btn-default" onClick={() => installFBTab()}>install as a facebook tab</button>
              </div>
            }
          </div> */}
          </div>
          :
          objWidget.wdtnm == 'automation_marketing' ?
            <div className="">
              <div className="inst-code-design">
                <h5>Copy and paste this code.</h5>
                <div className="inst-types-manually">
                  <div className="wdgt-code-script">
                    <pre>{_shareURL}</pre>
                  </div>
                  <div className="copy-script-upbg" id={divId} onClick={() => copyWidgetDiv(_shareURL, divId)}>
                    <div className="copy-script-content">
                      <div className="copy-text">Copy and paste this code into desired place of your website</div>
                      <a href="#" className="nf-btn nf-btn-default">
                        <span className="btn-copytext-dflt">Get code</span>
                        <span className="btn-copytext-hover">Copy code</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            :
            <div className="">
              <div className="inst-code-design">
                {/* <h5>Copy and paste this code into desired place of your website (HTML editor, website template, theme, etc)</h5> */}
                <div className="inst-types-manually">
                  <div className="wdgt-code-script">
                    <pre>{divTag}</pre>
                  </div>
                  <div className="copy-script-upbg" id={divId} onClick={() => copyWidgetDiv(divTag, divId)}>
                    <div className="copy-script-content">
                      <div className="copy-text">Copy and paste this code into desired place of your website</div>
                      <a href="#" className="nf-btn nf-btn-default">
                        <span className="btn-copytext-dflt">Get code</span>
                        <span className="btn-copytext-hover">Copy code</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        }
      </div>
      :
      <div className="modal-installation">
        <div className="modal-inst-header">
          <div className="int_not_selct">
            <img src={InteConnect} alt="InteConnect" />
            <h2 className='modal-inst-hdtitle'>Connect at least one data source to generate code</h2>
            <h3 className='copycode-paste-title'>Select your account if you’ve already connected</h3>
            <div className="copy-script-content"><a className='nf-btn nf-btn-default nf-green' onClick={() => setIntName()}>Go back to data source</a></div>
          </div>
        </div>
      </div>

  );
};

export default GetCodeCard;


// WEBPACK FOOTER //
// ./src/components/Widget/GetCodeCard.js